import React, { useState } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import restaurantImg from "../assets/restorent/restaurant.png";

/* ─── Schemas ───────────────────────────────────────────────────── */
const erodeFAQSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What makes Barbequeen the best restaurant in Erode?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Since 1999, we've combined genuine charcoal-grill craft with fresh ingredients, steady quality, and generous portions. From double-marinated grill chicken to biryani and mandi, it's why diners rate us the best restaurant in Erode.",
      },
    },
    {
      "@type": "Question",
      name: "Where can I find the best barbecue in Erode?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and slow-charred over charcoal. Paired with our kababs and tandoori plates, it's the best barbecue in Erode.",
      },
    },
    {
      "@type": "Question",
      name: "Which is the best biryani in Erode?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "We layer aged basmati with freshly marinated chicken or slow-cooked mutton over a gentle dum. Light, fragrant rice and tender meat make it the best biryani in Erode.",
      },
    },
    {
      "@type": "Question",
      name: "Where is Barbequeen located in Erode, and what are the timings?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "You'll find us on Perundurai Road, opposite Sudha Hospital in V Chatram. We're open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
      },
    },
    {
      "@type": "Question",
      name: "Does Barbequeen Erode offer delivery and vegetarian options?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, we offer doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
      },
    },
  ],
};

const erodeRestaurantSchema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://barbequeen.com/#organization",
      name: "Barbequeen Restaurant",
      url: "https://barbequeen.com/",
      logo: "https://barbequeen.com/images/logo.png",
      foundingDate: "1999",
      sameAs: [
        "https://facebook.com/BarbequeenRestaurant/",
        "https://instagram.com/barbequeenrestaurant/",
      ],
    },
    {
      "@type": "Restaurant",
      "@id": "https://barbequeen.com/best-restaurant-in-erode#erode",
      name: "Barbequeen - Erode",
      image: "https://barbequeen.com/images/barbequeen-erode.jpg",
      url: "https://barbequeen.com/best-restaurant-in-erode",
      telephone: "+919003760005",
      priceRange: "₹₹",
      servesCuisine: [
        "Barbecue",
        "Grill",
        "Tandoori",
        "Arabian",
        "North Indian",
        "Biryani",
        "Chinese",
      ],
      parentOrganization: { "@id": "https://barbequeen.com/#organization" },
      address: {
        "@type": "PostalAddress",
        streetAddress: "9, 10, Perundurai Rd, Opp. Sudha Hospital, V Chatram",
        addressLocality: "Erode",
        addressRegion: "Tamil Nadu",
        postalCode: "638011",
        addressCountry: "IN",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "11.3410",
        longitude: "77.7172",
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        opens: "11:00",
        closes: "23:00",
      },
    },
  ],
};

const FAQS = [
  {
    q: "What makes Barbequeen the best restaurant in Erode?",
    a: "Since 1999, we've combined genuine charcoal-grill craft with fresh ingredients, steady quality, and generous portions. From double-marinated grill chicken to biryani and mandi, it's why diners rate us the best restaurant in Erode.",
  },
  {
    q: "Where can I find the best barbecue in Erode?",
    a: "At Barbequeen, home of the Double Marinated Grill Chicken, marinated twice and slow-charred over charcoal. Paired with our kababs and tandoori plates, it's the best barbecue in Erode.",
  },
  {
    q: "Which is the best biryani in Erode?",
    a: "We layer aged basmati with freshly marinated chicken or slow-cooked mutton over a gentle dum. Light, fragrant rice and tender meat make it the best biryani in Erode.",
  },
  {
    q: "Where is Barbequeen located in Erode, and what are the timings?",
    a: "You'll find us on Perundurai Road, opposite Sudha Hospital in V Chatram. We're open daily, 11:00 AM to 11:00 PM, for dine-in, takeaway, and delivery.",
  },
  {
    q: "Does Barbequeen Erode offer delivery and vegetarian options?",
    a: "Yes, we offer doorstep delivery plus online ordering via Swiggy and Zomato. Our menu also has a full veg spread, from paneer butter masala to starters and desserts.",
  },
];

const OTHER_GUIDES = [
  {
    title: "Best Restaurant in Salem",
    path: "/best-restaurant-in-salem",
    city: "Salem",
  },
  {
    title: "Best Restaurant in Coimbatore",
    path: "/best-restaurant-in-coimbatore",
    city: "Coimbatore",
  },
  {
    title: "Best Restaurant in Krishnagiri",
    path: "/best-restaurant-in-krishnagiri",
    city: "Krishnagiri",
  },
  {
    title: "Best Restaurant in Pudukkottai",
    path: "/best-restaurant-in-pudukkottai",
    city: "Pudukkottai",
  },
];

const BestRestaurantInErodePage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (idx) => {
    setOpenFaq(openFaq === idx ? null : idx);
  };

  const pageTitle = "Best Restaurant in Erode | Barbequeen – Grill & Barbecue";
  const pageUrl = "https://barbequeen.com/best-restaurant-in-erode";

  return (
    <div
      className="min-h-screen bg-[#f9f5f0]"
      style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif" }}
    >
      {/* ── SEO & Schemas ── */}
      <SEO
        title={pageTitle}
        metaTitle={pageTitle}
        description="Barbequeen — top restaurant in Erode since 1999. Double-marinated charcoal grill chicken, biryani & Arabian mandi on Perundurai Rd. Dine-in or order online."
        keywords="Best Restaurant in Erode, Best Barbecue in Erode, Best Biryani in Erode"
        robots="index, follow"
        canonical={pageUrl}
        geo={{
          region: "IN-TN",
          placename: "Erode, Tamil Nadu",
          position: "11.3410;77.7172",
          icbm: "11.3410, 77.7172",
        }}
        og={{
          type: "website",
          url: pageUrl,
          title: pageTitle,
          description:
            "Home of the Double Marinated Grill Chicken. Charcoal barbecue, biryani & Arabian mandi in Erode. Dine-in, takeaway & delivery.",
          image: "https://barbequeen.com/images/barbequeen-erode-og.jpg",
          imageWidth: "1200",
          imageHeight: "630",
          siteName: "Barbequeen Restaurant",
          locale: "en_IN",
        }}
        schema={[erodeRestaurantSchema, erodeFAQSchema]}
      />

      {/* ── Hero Banner (Blog Style) ── */}
      <section
        className="relative overflow-hidden"
        style={{ minHeight: "360px" }}
      >
        <img
          src="https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=1600&auto=format&fit=crop"
          alt="Best Restaurant in Erode - Barbequeen"
          className="absolute inset-0 w-full h-full object-cover object-center scale-105"
          onError={(e) => {
            e.target.src = restaurantImg;
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to bottom, rgba(10,0,2,0.82) 0%, rgba(10,0,2,0.92) 100%)",
          }}
        />

        <div className="relative z-10 max-w-6xl mx-auto px-4 lg:px-8 pt-28 sm:pt-32 pb-14 text-left">
          {/* Breadcrumbs */}
          <nav className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-white/60 mb-5">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            <svg
              className="w-3 h-3 text-white/40"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <Link to="/blog" className="hover:text-white transition-colors">
              Blog
            </Link>
            <svg
              className="w-3 h-3 text-white/40"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 5l7 7-7 7"
              />
            </svg>
            <span className="text-white/90 font-medium truncate max-w-[200px] sm:max-w-xs">
              Erode Guide
            </span>
          </nav>

          {/* Category Tag */}
          <span className="inline-block px-3 py-1 rounded-full text-white text-[10px] font-bold tracking-[0.2em] uppercase mb-4 bg-[#9b1c2e]">
            Restaurant Guide • Erode
          </span>

          {/* Title */}
          <h1 className="text-2xl sm:text-4xl lg:text-[40px] font-bold text-white leading-snug tracking-wide uppercase max-w-4xl mb-4">
            Best Restaurant in Erode - Barbequeen Restaurant
          </h1>

          {/* Meta Bar */}
          <div className="flex flex-wrap items-center gap-5 text-xs text-white/80 font-sans pt-2">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-full bg-[#9b1c2e] flex items-center justify-center text-white font-bold text-xs">
                B
              </div>
              <span className="font-semibold text-white">
                Barbequeen Editorial
              </span>
            </div>
            <span className="text-white/30">•</span>
            <div className="flex items-center gap-1.5 text-white/70">
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>5 min read</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Author / Social Share Row ── */}
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-4 py-5 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#9b1c2e] flex items-center justify-center flex-shrink-0 text-white font-bold text-sm">
              B
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-800">
                Barbequeen Editorial
              </p>
              <p className="text-xs text-gray-400">
                Serving Erode & Tamil Nadu Since 1999
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="px-3 py-1 rounded-full border border-gray-200 text-xs font-semibold text-gray-600 uppercase tracking-wide bg-white">
              Erode City Guide
            </span>
            <span className="text-sm text-gray-500">Perundurai Road</span>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-400 font-medium">Share:</span>
            <a
              href="https://instagram.com/barbequeenrestaurant"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-[#9b1c2e] hover:text-[#9b1c2e] transition-colors"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
              </svg>
            </a>
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}&text=${encodeURIComponent(pageTitle)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-[#9b1c2e] hover:text-[#9b1c2e] transition-colors"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a
              href={`https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center text-gray-500 hover:border-[#9b1c2e] hover:text-[#9b1c2e] transition-colors"
            >
              <svg
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* ── Main Content + Sidebar Layout ── */}
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          {/* ── Left Column: Article Body ── */}
          <main className="lg:col-span-8">
            {/* Excerpt */}
            <p className="text-[16px] text-gray-700 leading-[1.85] mb-8 italic border-l-4 border-[#9b1c2e] pl-4 bg-white p-4 rounded-r-lg shadow-sm">
              Erode has always appreciated good food, but when it comes to
              authentic charcoal-fired barbecue, aromatic wood-fire dum biryani,
              and rich Arabian mandi, one destination stands out above the rest.
              Since 1999, Barbequeen Restaurant has delighted food enthusiasts
              with generous portions, bold marinades, and an inviting family
              atmosphere, proudly earning its reputation as the{" "}
              <strong>Best Restaurant in Erode</strong>.
            </p>

            {/* Section 1 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              The Barbequeen Experience in Erode
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              Conveniently located on Perundurai Road opposite Sudha Hospital,
              Barbequeen Erode welcomes guests with the rich aromas of glowing
              charcoal, warm spices, and sizzling meats. From casual lunches and
              festive weekend dinners to celebratory get-togethers, our
              welcoming ambience and attentive hospitality ensure every meal is
              a special occasion.
            </p>

            {/* Section 2 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              Signature Charcoal Grills: Home of the Double Marinated Grill
              Chicken
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              Our culinary hallmark is the celebrated Double Marinated Grill
              Chicken. Hand-marinated twice in a secret blend of herbs and
              spices before slow-charring over natural charcoal, it delivers an
              irresistible combination of crispy smoky skin and tender, juicy
              meat. Diners in Erode also love our freshly crafted Chicken
              Shawarma, fiery Pepper Chicken Tikka, and generous BBQ Platters,
              confirming why we are considered the best barbecue in Erode.
            </p>

            {/* Section 3 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              Fragrant Wood-Fire Dum Biryani & Mandi Delights
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              Our kitchen takes immense pride in our authentic Dum Biryani.
              Slow-cooked over gentle embers using premium aged basmati rice,
              farm-fresh chicken, or tender mutton, every grain bursts with
              aroma and balanced spice. For families and gatherings, our Family
              Bucket Biryani and lavish Arabian Chicken Mandi, garnished with
              fried onions, cashews, and raisins, offer the ultimate communal
              dining experience.
            </p>

            {/* Section 4 */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              A Diverse Spread for Every Craving
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-3">
              The menu at Barbequeen Erode satisfies every member of the family
              with multi-cuisine offerings:
            </p>
            <div className="space-y-2 mb-6">
              {[
                "Tandoori Chicken, Malai Tikka & freshly baked Garlic Butter Naan",
                "Spicy Dragon Chicken, Chilli Fish & Schezwan Fried Rice",
                "Rich North Indian curries including Butter Chicken and Kadai Gravy",
                "Wholesome vegetarian specialties including Paneer Butter Masala and Mushroom Gravy",
              ].map((item, idx) => (
                <div key={idx} className="flex gap-3 items-start">
                  <span className="w-2 h-2 rounded-full bg-[#9b1c2e] mt-2 flex-shrink-0" />
                  <p className="text-[15px] text-gray-700 leading-[1.8] flex-1">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            {/* Section 5: Outlet Details */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-10 mb-4 border-b border-gray-200 pb-2">
              Visit Barbequeen in Erode
            </h2>
            <div className="bg-white rounded-xl p-6 border border-gray-200 hover:border-[#9b1c2e]/40 hover:shadow-md transition-all duration-200 mb-8">
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Barbequeen Restaurant - Perundurai Road
              </h3>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                9, 10, Perundurai Rd, Opposite Sudha Hospital, V Chatram, Erode,
                Tamil Nadu 638011
              </p>
              <div className="flex flex-wrap items-center justify-between gap-4 pt-4 border-t border-gray-100 text-sm">
                <a
                  href="tel:+919003760005"
                  className="font-bold text-[#9b1c2e] hover:underline flex items-center gap-1.5"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                  +91 90037 60005
                </a>
                <a
                  href="https://google.com/maps/search/?api=1&query=Barbequeen+Perundurai+Rd+Opp+Sudha+Hospital+Erode"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-[#9b1c2e] font-semibold"
                >
                  View on Google Maps →
                </a>
              </div>
            </div>

            {/* Section 6: Dine-In, Takeaway & Delivery */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-8 mb-4 border-b border-gray-200 pb-2">
              Dine-In, Takeaway & Delivery in Erode
            </h2>
            <p className="text-[15px] text-gray-600 leading-[1.85] mb-4">
              Barbequeen Erode is open daily from{" "}
              <strong>11:00 AM to 11:00 PM</strong>. Enjoy our full dine-in
              experience or pick up a quick takeaway. For doorstep delivery,
              order online via our website, Swiggy, or Zomato to savor freshly
              grilled barbecue and hot dum biryani in the comfort of your home.
            </p>

            {/* Section 7: FAQs */}
            <h2 className="text-2xl font-bold text-gray-900 leading-snug mt-12 mb-6 border-b border-gray-200 pb-2">
              Frequently Asked Questions
            </h2>
            <div className="space-y-3 mb-10">
              {FAQS.map((faq, idx) => (
                <div
                  key={idx}
                  className="bg-white rounded-xl border border-gray-200 overflow-hidden transition-all duration-200"
                >
                  <button
                    onClick={() => toggleFaq(idx)}
                    className="w-full px-5 py-4 text-left flex items-center justify-between gap-4 font-semibold text-gray-800 text-sm hover:text-[#9b1c2e] transition-colors"
                  >
                    <span>{faq.q}</span>
                    <span className="text-[#9b1c2e] text-lg font-bold flex-shrink-0">
                      {openFaq === idx ? "−" : "+"}
                    </span>
                  </button>
                  {openFaq === idx && (
                    <div className="px-5 pb-4 text-xs sm:text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
                      {faq.a}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Tags / Bottom Share */}
            <div className="mt-10 pt-6 border-t border-gray-200 flex flex-wrap items-center justify-between gap-4">
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <span className="font-semibold text-gray-700">Tags:</span>
                <span className="bg-gray-100 px-2.5 py-1 rounded-md">
                  Best Restaurant in Erode
                </span>
                <span className="bg-gray-100 px-2.5 py-1 rounded-md">
                  Erode Biryani
                </span>
                <span className="bg-gray-100 px-2.5 py-1 rounded-md">
                  Perundurai Road
                </span>
              </div>
              <a
                href={`https://wa.me/?text=${encodeURIComponent(pageTitle + " " + pageUrl)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 bg-[#25d366] text-white text-xs font-bold rounded-lg hover:opacity-90 transition-opacity"
              >
                Share on WhatsApp
              </a>
            </div>
          </main>

          {/* ── Right Column: Sidebar ── */}
          <aside className="lg:col-span-4 space-y-6">
            {/* Other Cities Widget */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100 flex items-center gap-2">
                <span className="w-2.5 h-2.5 rounded-full bg-[#9b1c2e]"></span>
                Other City Guides
              </h3>
              <div className="space-y-3">
                {OTHER_GUIDES.map((guide, idx) => (
                  <Link
                    key={idx}
                    to={guide.path}
                    className="group block p-3 rounded-xl bg-gray-50 hover:bg-[#9b1c2e]/5 border border-transparent hover:border-[#9b1c2e]/20 transition-all duration-200"
                  >
                    <span className="text-xs font-bold uppercase tracking-wider text-[#9b1c2e] block mb-0.5">
                      {guide.city}
                    </span>
                    <p className="text-sm font-semibold text-gray-800 group-hover:text-[#9b1c2e] transition-colors">
                      {guide.title} →
                    </p>
                  </Link>
                ))}
              </div>
            </div>

            {/* Quick Actions Widget */}
            <div className="bg-[#1a0a0d] text-white rounded-2xl p-6 shadow-md">
              <span className="text-[10px] font-bold tracking-[0.25em] text-[#c0424e] uppercase block mb-2">
                SINCE 1999
              </span>
              <h3 className="text-lg font-bold mb-3">Visit Barbequeen Erode</h3>
              <p className="text-xs text-gray-300 leading-relaxed mb-5">
                Enjoy authentic double marinated charcoal grill, wood-fire dum
                biryani, or Arabian mandi on Perundurai Road.
              </p>
              <div className="space-y-2.5">
                <Link
                  to="/menu"
                  className="block w-full py-2.5 text-center bg-[#9b1c2e] hover:bg-[#801423] text-white text-xs font-bold rounded-xl uppercase tracking-wider transition-colors"
                >
                  Explore Full Menu
                </Link>
                <Link
                  to="/contact-us"
                  className="block w-full py-2.5 text-center bg-white/10 hover:bg-white/20 border border-white/20 text-white text-xs font-bold rounded-xl uppercase tracking-wider transition-colors"
                >
                  Contact & Directions
                </Link>
              </div>
            </div>

            {/* Why Barbequeen Widget */}
            <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-sm">
              <h3 className="text-base font-bold text-gray-900 mb-4 pb-2 border-b border-gray-100">
                Why Diners Choose Us
              </h3>
              <ul className="space-y-3 text-xs text-gray-600">
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>Double Marinated:</strong> Signature spice blend
                    infused deep into the meat.
                  </span>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>Real Charcoal Fire:</strong> Traditional authentic
                    grilling technique.
                  </span>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>25+ Years Legacy:</strong> Serving families with
                    consistent taste since 1999.
                  </span>
                </li>
                <li className="flex items-start gap-2.5">
                  <span className="text-[#9b1c2e] font-bold">✓</span>
                  <span>
                    <strong>Prime Location:</strong> Perundurai Rd, opposite
                    Sudha Hospital.
                  </span>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default BestRestaurantInErodePage;
